import * as types from '@/store/types';
import service from '@/api/NotificationService'
import store from '@/store'
import moment from 'moment'
import momenttz from 'moment-timezone'

export default {
    [types.ACTION_ADMIN_NOTIFICATION_LIST]: ({commit}) => {
        service.fetchAll()
        	.then( (response) => {
        		commit(types.MUTATE_NOTIFICATION_LIST, response)
        	})
    },
    [types.ACTION_USER_NOTIFICATION_LIST]: ({commit}, payload) => {
        service.fetchByAgency(payload)            
        	.then( (response) => {
        		commit(types.MUTATE_USER_NOTIFICATION_LIST, response)
        	})
    },
    [types.ACTION_UPDATE_NOTIFICATION_STATUS]: ({commit}, payload) => {
        service.updateNotificationStatus(payload)
    },
    [types.ACTION_UPDATE_NOTIFICATION_REQUEST]: ({commit}, payload) => {
        service.updateNotificationRequest(payload).then( (response) => {                
                commit(types.MUTATE_START_DATE, response.start_date)
            })
    },
    [types.ACTION_DELETE_NOTIFICATION]: ({commit}, payload) => {
        service.deleteNotification(payload)
    },
    [types.ACTION_DASHBOARD_STATISTICS]: ({commit}, payload) => {
        service.fetchDashboardStatistics(payload).then( (response) => {
            commit(types.MUTATE_DASHBOARD_STATISTICS, response)
        })
    },
    [types.ACTION_TRACKING_SHEET]: ({commit}, payload) => {
        service.fetchTrackingSheet(payload).then( (response) => {
            commit(types.MUTATE_TRACKING_SHEET, response)
        })
    }
}


// WEBPACK FOOTER //
// ./src/store/modules/notification/actions.js